import { useState } from 'react'
import { useSpendContext } from './useSpendContext';
import { ApiUrl } from '../services'
import { axiosInstance as axios } from '../AxiosToken';
import { manageErrorPigApi, sleep } from '../utils';

export const useDelete = () => {
  const { dispatch } = useSpendContext()
  const [errorDelete, setError] = useState(null)
  const [respDelete, setResponse] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const Delete = async (path) => {
    setIsLoading(true)
    setError(null)
    let url = ApiUrl()
    try {
      let lnk = `${url}/api/${path}`
      if (process.env.NODE_ENV !== 'production') {
        const sleepDuration = 100
        console.group('Delete Request')
        console.log('useDelete: ', lnk);
        // console.log('data: ', JSON.stringify(data));
        // console.table(data)
        await sleep(sleepDuration)
        console.warn(`SLEEP ${sleepDuration}ms Enabled in useDelete.jsx`)
        console.groupEnd()
      }
      const respAxios = await axios.delete(lnk)
      let result = respAxios.data
      // console.log('getExpenses Responses Axios', result)
      setResponse(result)
      setIsLoading(false)
    } catch (error) {
      let errorMessage = manageErrorPigApi(error)
      console.log(error)
      setError(error)
      dispatch({
        type: 'SET_NOTIF', payload: {
          message: (errorMessage) ? errorMessage : error.message,
          type: 'error'
        }
      })
      setIsLoading(false)
    }
  }
  return { Delete, isLoading, errorDelete, respDelete }
}


